// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height' | 'color'>
const SvgFiletypeDoc = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 158 206"
    {...props}
  >
    <path
      fill="#999"
      d="M0 4a4 4 0 0 1 4-4h95.807c2.366 0 4.637.932 6.322 2.595l33.193 32.762A9 9 0 0 1 142 41.762V183a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      d="M4 6a2 2 0 0 1 2-2h92a2 2 0 0 1 2 2v26.5c0 5.523 4.477 10 10 10h26a2 2 0 0 1 2 2V181a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
    />
    <path
      fill="#999"
      d="M106.35 72.043H57.969c-.465 0-.911-.318-1.24-.885s-.513-1.336-.513-2.138c0-.397.044-.791.132-1.159s.217-.702.38-.984c.162-.281.356-.504.569-.657a1.15 1.15 0 0 1 .672-.23h48.381c.466 0 .913.319 1.243.887s.515 1.34.515 2.143c-.002.803-.187 1.572-.517 2.139-.329.566-.775.884-1.241.884M46.928 64.63v10.603a2 2 0 0 1-2 2h-1.64a2 2 0 0 1-2-2V64.63h-4.694a2 2 0 0 1-2-2v-.696a2 2 0 0 1 2-2h15.027a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2zM105.589 88.199H36.242c-.667 0-1.305-.34-1.777-.947-.47-.607-.736-1.43-.736-2.288 0-.425.064-.847.19-1.24.126-.394.31-.751.544-1.052.233-.302.51-.54.816-.704s.632-.247.963-.247h69.347c.668 0 1.309.342 1.781.95s.738 1.433.738 2.293c-.002.86-.268 1.682-.74 2.288-.473.606-1.112.947-1.779.947M105.589 104.19H36.242c-.33 0-.658-.084-.963-.247a2.6 2.6 0 0 1-.816-.703 3.4 3.4 0 0 1-.544-1.053 4 4 0 0 1-.19-1.24c0-.858.265-1.68.736-2.287s1.11-.948 1.777-.948h69.347c.667 0 1.307.34 1.779.947s.738 1.429.74 2.288c0 .86-.266 1.685-.738 2.293s-1.113.95-1.781.95M78.224 119.317H36.242c-.33 0-.658-.084-.963-.247a2.6 2.6 0 0 1-.816-.704 3.4 3.4 0 0 1-.544-1.052 4 4 0 0 1-.19-1.24c0-.858.265-1.681.736-2.288s1.11-.947 1.777-.947h41.982c.666 0 1.305.341 1.776.947.471.607.736 1.43.736 2.288 0 .425-.064.847-.19 1.24a3.4 3.4 0 0 1-.544 1.052 2.6 2.6 0 0 1-.816.704 2.04 2.04 0 0 1-.963.247M22 166a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v36a4 4 0 0 1-4 4H26a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      d="m127.107 179.613-4.523.952c-.265-.952-.476-1.455-.873-2.01-.793-1.164-2.063-1.746-3.703-1.746-1.508 0-2.804.502-3.729 1.481-1.217 1.27-1.878 3.306-1.878 5.845 0 4.629 2.142 7.433 5.686 7.433 1.667 0 3.042-.635 3.862-1.799.423-.634.635-1.19.82-2.354l4.602.741c-.529 2.116-1.031 3.227-1.983 4.364-1.561 1.878-4.127 2.883-7.274 2.883-3.016 0-5.581-.952-7.3-2.724-1.931-1.984-2.989-5.026-2.989-8.517 0-3.597 1.137-6.613 3.28-8.676 1.719-1.64 4.073-2.486 6.929-2.486 3.307 0 5.872 1.137 7.539 3.333.767 1.005 1.164 1.851 1.534 3.28M94.034 173c2.989 0 5.396.899 7.221 2.751 1.984 1.957 3.042 4.92 3.042 8.384 0 6.825-4.074 11.295-10.263 11.295-6.242 0-10.263-4.418-10.263-11.268 0-6.798 4.02-11.162 10.263-11.162m.027 18.594c3.517 0 5.686-2.83 5.686-7.432 0-2.592-.687-4.602-1.957-5.872-.979-.979-2.275-1.481-3.756-1.481-3.518 0-5.74 2.83-5.74 7.3 0 4.602 2.222 7.485 5.767 7.485M61.42 191.383V177.02c0-1.639-.054-2.459-.239-3.65 1.058.053 1.72.08 3.624.08h5.158c3.253 0 5.66.793 7.38 2.46 1.93 1.878 2.935 4.628 2.935 8.093 0 3.624-1.058 6.507-3.095 8.491-1.745 1.666-4.073 2.46-7.194 2.46h-5.184c-1.799 0-2.513.026-3.597.079.158-1.137.211-1.957.211-3.65m4.364-.265h3.861c1.958 0 3.28-.476 4.285-1.534 1.19-1.243 1.825-3.147 1.825-5.501 0-2.407-.555-4.153-1.693-5.317-1.005-1.031-2.327-1.481-4.443-1.481h-3.835zM52 190.378h4.576v4.576H52z"
    />
  </svg>
)
export default SvgFiletypeDoc
